import styled, { css } from 'styled-components'

export const TooltipContent = styled.div`
	${({ width }) => width && css`
		width: ${width};
	`}
	position: absolute;
	left: -20px;
	display: flex;
	flex-direction: column;
	padding: 15px;

	z-index: 1;

	border-radius: 3.671px;
	border: 0.459px solid var(--Color-Border-one, #E0E0E0);
	background: var(--Color-Surface-default, #FAFAFA);
	box-shadow: 0px 0px 0.459px 0.459px rgba(0, 0, 0, 0.12), 0px 1.835px 5.506px 1.835px rgba(0, 0, 0, 0.25);

	@media(max-width: 767px) {
		width: 100%;
	}
`

export const TooltipTitle = styled.div`
	display: flex;
	position: relative;
	gap: 5px;

	span {
		margin-bottom: 15px;

		color: #230C87;
		font-family: "Work Sans";
		font-weight: 500 !important;
		font-size: 14px;
		font-style: normal;
		line-height: normal;
		text-decoration: underline;

		cursor: text !important;
	}

	button {
		padding: 3px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		top: -7px;
		height: min-content;
		width: min-content;

		background: transparent;
		border: none;

		@media(max-width: 767px) {
			padding: 7px;
		}
	}
`

export const TooltipDescription = styled.p`
	color: #230C87;
	font-family: "Work Sans";
	font-size: 14px;
	font-style: normal;
	line-height: normal;
`
